export default __webpack_public_path__ + "static/touch-icon-144-5248071c9417104efd7aeb0b1f24b548.png";